(() => {
  'use strict';
  const $ = (selector, context = document) => context.querySelector(selector);
  const root = window.Shopify?.routes?.root || '/';
  const drawer = $('[data-cart-drawer]');
  const money = cents => new Intl.NumberFormat(document.documentElement.lang || 'nl-NL', { style: 'currency', currency: window.Shopify?.currency?.active || 'EUR' }).format(cents / 100);

  async function refreshCart() {
    const [sectionResponse, cartResponse] = await Promise.all([
      fetch(root + '?section_id=hzn-cart-drawer', { credentials: 'same-origin' }),
      fetch(root + 'cart.js', { credentials: 'same-origin' })
    ]);
    if (!sectionResponse.ok || !cartResponse.ok) throw Error('Winkelwagen kon niet worden bijgewerkt');
    const markup = await sectionResponse.text();
    const next = new DOMParser().parseFromString(markup, 'text/html').querySelector('[data-cart-drawer]');
    if (!next || !drawer) throw Error('Winkelwagenpaneel ontbreekt');
    drawer.innerHTML = next.innerHTML;
    const cart = await cartResponse.json();
    document.querySelectorAll('[data-cart-count]').forEach(node => node.textContent = cart.item_count);
    return cart;
  }
  function openCart() { if (!drawer) { location.href = root + 'cart'; return; } if (!drawer.open) drawer.showModal(); const sticky = $('[data-mobile-purchase]'); if (sticky) sticky.hidden = true; $('[data-cart-close]', drawer)?.focus(); }
  document.addEventListener('click', async event => {
    if (event.target.closest('[data-cart-open]')) { event.preventDefault(); try { await refreshCart(); } catch {} openCart(); }
    if (event.target.closest('[data-cart-close]')) drawer?.close();
    const control = event.target.closest('[data-cart-change]');
    if (!control) return;
    control.disabled = true;
    try {
      const response = await fetch(root + 'cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ line: Number(control.dataset.cartChange), quantity: Number(control.dataset.cartQuantity) }) });
      if (!response.ok) throw Error('Bijwerken mislukt');
      await refreshCart();
    } catch { control.disabled = false; location.href = root + 'cart'; }
  });
  drawer?.addEventListener('click', event => { if (event.target === drawer) drawer.close(); });
  document.addEventListener('submit', async event => {
    const form = event.target;
    if (!form.matches('[data-quick-add], [data-product-form]')) return;
    event.preventDefault();
    const button = $('[type=submit]', form);
    if (button) button.disabled = true;
    let itemAdded = false;
    try {
      const response = await fetch(root + 'cart/add.js', { method: 'POST', body: new FormData(form) });
      if (!response.ok) { const error = await response.json(); throw Error(error.description || 'Toevoegen is niet gelukt'); }
      itemAdded = true;
      await refreshCart();
      openCart();
    } catch (error) {
      if (itemAdded) { location.href = root + 'cart'; return; }
      const message = $('[data-cart-error]');
      if (message) { message.textContent = error.message; message.hidden = false; }
      else alert(error.message || 'Toevoegen is niet gelukt. Probeer het opnieuw.');
    } finally { if (button) button.disabled = false; }
  });

  // Shopify predictive search respects the store catalog and Search & Discovery setup.
  const input = $('#header-search'), results = $('#predictive-results');
  let timer, request;
  async function suggestions(query) {
    request?.abort(); request = new AbortController();
    const fetchProducts = async terms => {
      const url = root + 'search/suggest.json?q=' + encodeURIComponent(terms) + '&resources[type]=product&resources[limit]=6';
      const response = await fetch(url, { signal: request.signal });
      if (!response.ok) throw Error('Zoeken niet beschikbaar');
      return (await response.json()).resources.results.products || [];
    };
    try {
      let products = await fetchProducts(query);
      if (!products.length && query.trim().split(/\s+/).length === 2) products = await fetchProducts(query.trim().split(/\s+/).reverse().join(' '));
      results.replaceChildren();
      const list = document.createElement('div');
      list.className = 'predictive-list';
      products.forEach(product => {
        const link = document.createElement('a'); link.href = product.url;
        if (product.image) { const image = document.createElement('img'); image.src = product.image; image.alt = ''; image.loading = 'lazy'; link.append(image); }
        const copy = document.createElement('span');
        const title = document.createElement('strong'); title.textContent = product.title;
        const detail = document.createElement('small'); detail.textContent = [product.type, new Intl.NumberFormat(document.documentElement.lang || 'nl-NL', { style: 'currency', currency: window.Shopify?.currency?.active || 'EUR' }).format(Number(product.price))].filter(Boolean).join(' · ');
        copy.append(title, detail); link.append(copy); list.append(link);
      });
      if (!products.length) { const empty = document.createElement('p'); empty.textContent = 'Geen producten gevonden. Probeer een andere naam of geur.'; list.append(empty); }
      const all = document.createElement('a'); all.href = root + 'search?q=' + encodeURIComponent(query) + '&type=product'; all.className = 'text-link'; all.textContent = 'Bekijk alle zoekresultaten';
      results.append(list, all); results.hidden = false; input.setAttribute('aria-expanded', 'true');
    } catch (error) { if (error.name !== 'AbortError') results.hidden = true; }
  }
  input?.addEventListener('input', () => { clearTimeout(timer); if (input.value.trim().length < 2) { results.hidden = true; input.setAttribute('aria-expanded', 'false'); return; } timer = setTimeout(() => suggestions(input.value.trim()), 180); });
  document.addEventListener('click', event => { if (!event.target.closest('.header-search') && results) results.hidden = true; });
  input?.addEventListener('keydown', event => { if (event.key === 'Escape') { results.hidden = true; input.setAttribute('aria-expanded', 'false'); } });

  const variant = $('[data-variant-select]'), primary = $('[data-product-add]'), sticky = $('[data-mobile-purchase]');
  function syncPriceAndStock() {
    if (!variant) return;
    const option = variant.selectedOptions[0], compare = $('[data-compare-price]'), count = option.dataset.stock;
    if (compare) { compare.hidden = !option.dataset.compare; compare.textContent = option.dataset.compare || ''; }
    const stock = $('[data-stock]'), threshold = Number($('[data-product-page]')?.dataset.lowStock || 3);
    if (stock) {
      stock.replaceChildren();
      if (option.dataset.available !== 'true') stock.textContent = 'Tijdelijk uitverkocht';
      else if (count !== '' && Number(count) > 0 && Number(count) <= threshold) { const dot = document.createElement('i'); dot.className = 'amber-dot'; stock.append(dot, 'Nog ' + count + ' op voorraad'); }
      else { const dot = document.createElement('i'); stock.append(dot, 'Op voorraad'); }
    }
  }
  variant?.addEventListener('change', syncPriceAndStock); syncPriceAndStock();
  function syncSticky() { if (sticky && primary) sticky.hidden = !(matchMedia('(max-width:760px)').matches && primary.getBoundingClientRect().bottom < 0 && !drawer?.open); }
  window.addEventListener('scroll', syncSticky, { passive: true }); window.addEventListener('resize', syncSticky); drawer?.addEventListener('close', syncSticky); drawer?.addEventListener('cancel', syncSticky);
  let touchX = null;
  const gallery = $('.pdp-gallery');
  gallery?.addEventListener('touchstart', e => { if (e.target.id === 'product-featured') touchX = e.touches[0].clientX; }, { passive: true });
  gallery?.addEventListener('touchend', e => {
    if (touchX === null || e.target.id !== 'product-featured') return;
    const distance = e.changedTouches[0].clientX - touchX; touchX = null;
    if (Math.abs(distance) < 45) return;
    const buttons = [...gallery.querySelectorAll('[data-gallery-image]')];
    const index = buttons.findIndex(b => b.getAttribute('aria-pressed') === 'true');
    buttons[(index + (distance < 0 ? 1 : -1) + buttons.length) % buttons.length]?.click();
  }, { passive: true });
})();
